import { API_CALLS } from "@/services/apis/index.js";

export default {
  getPlatforms(context) {
    console.log(context);
    return new Promise((resolve, reject) => {
      API_CALLS.getPlatformsAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPlatformUploadHistory(context) {
    console.log(context);
    return new Promise((resolve, reject) => {
      API_CALLS.getPlatformUploadHistoryAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPlatformUploadHistorySuccess(context, id) {
    return new Promise((resolve, reject) => {
      API_CALLS.getPlatformUploadHistorySuccessAPI(id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPlatformUploadHistoryFailed(context, id) {
    return new Promise((resolve, reject) => {
      API_CALLS.getPlatformUploadHistoryFailedAPI(id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  resolveProductPlatform(context, data) {
    console.log(context);
    return new Promise((resolve, reject) => {
      API_CALLS.resolveProductPlatformAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveTranslationsOnPlatforms(context, data) {
    console.log(context);
    return new Promise((resolve, reject) => {
      API_CALLS.saveTranslationsOnPlatformsAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMissingPlatformParameters(context, data) {
    console.log(context);
    return new Promise((resolve, reject) => {
      API_CALLS.getMissingPlatformParametersAPI(data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  uploadProducts(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.uploadProductsAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  exportToPiguLt(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.exportToPiguLtAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
